<template>
  <div
    :style="style"
    class="search-ads-campaigns-stats-chart-legend"
    :class="{ 'search-ads-campaigns-stats-chart-legend--inactive': !isActive }"
    v-on="$listeners"
  >
    <span class="search-ads-campaigns-stats-chart-legend__value">
      {{ value }}
    </span>
    <span class="search-ads-campaigns-stats-chart-legend__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SearchAdsCampaignsStatsChartLegend',
  props: {
    color: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    style() {
      return {
        borderColor: this.color,
      };
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns-stats-chart-legend {
  padding: $global-padding * 0.25 $global-padding / 2;
  border: 2px solid;
  border-radius: $lb-border-radius * 2;
  cursor: pointer;
  user-select: none;

  display: flex;
  flex-direction: column;

  transition-duration: 0.2s;

  &--inactive {
    opacity: 0.2;
  }

  &__value {
    font-weight: bold;
    font-size: rem-calc(20px);
  }
}
</style>
